"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.generateRegexRange = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactTextMask = _interopRequireDefault(require("react-text-mask"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _payment = _interopRequireDefault(require("payment"));

var _Icon = _interopRequireDefault(require("../Icon"));

require("../assets/css/input.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var generateRegexRange = function generateRegexRange(start, end) {
  var orRegex = '|';
  var regexResult = '';
  start = parseInt(start, 10);
  end = parseInt(end, 10);

  if (!(start >= 0 && end > 0)) {
    return false;
  }

  for (var i = start; i <= end; i++) {
    regexResult += '(' + i + ')';

    if (i < end) {
      regexResult += orRegex;
    }
  }

  return regexResult;
};

exports.generateRegexRange = generateRegexRange;

var getEloPattern = function getEloPattern() {
  var regexPattern = '^(' + generateRegexRange(457631, 457632) + '|';
  regexPattern += generateRegexRange(506699, 506778) + '|';
  regexPattern += generateRegexRange(509000, 509999) + '|';
  regexPattern += generateRegexRange(650031, 650033) + '|';
  regexPattern += generateRegexRange(650035, 650051) + '|';
  regexPattern += generateRegexRange(650405, 650439) + '|';
  regexPattern += generateRegexRange(650485, 650538) + '|';
  regexPattern += generateRegexRange(650541, 650598) + '|';
  regexPattern += generateRegexRange(650700, 650718) + '|';
  regexPattern += generateRegexRange(650720, 650727) + '|';
  regexPattern += generateRegexRange(650901, 650978) + '|';
  regexPattern += generateRegexRange(651652, 651679) + '|';
  regexPattern += generateRegexRange(655000, 655019) + '|';
  regexPattern += generateRegexRange(655021, 655058) + ')';
  return new RegExp(regexPattern);
};

var InputCard =
/*#__PURE__*/
function (_Component) {
  _inherits(InputCard, _Component);

  function InputCard() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, InputCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(InputCard)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      value: '',
      issuer: 'none',
      showErrorMessage: false,
      stopChangingIssuer: false
    });

    _defineProperty(_assertThisInitialized(_this), "updateCards", function () {
      var rules = _this.getRules();

      for (var i = rules.length - 1; i >= 0; i--) {
        _payment.default.getCardArray().unshift(rules[i]);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getRules", function () {
      return [{
        cvcLength: [3],
        pattern: /^((((457393)|(431274)|(627780)|(636368)|(438935)|(504175)|(451416)|(636297))\d{0,10})|((5067)|(4576)|(4011))\d{0,12})$/,
        format: /(\d{1,4})/g,
        length: [16],
        luhn: true,
        type: 'elo'
      }, {
        cvcLength: [3],
        pattern: getEloPattern(),
        format: /(\d{1,4})/g,
        length: [16],
        luhn: true,
        type: 'elo'
      }, {
        cvcLength: [3],
        pattern: /^(4011(78|79)|43(1274|8935)|45(1416|7393|763(1|2))|50(4175|6699|67[0-7][0-9]|9000)|50(9[0-9][0-9][0-9])|627780|63(6297|6368)|650(03([^4])|04([0-9])|05(0|1)|05([7-9])|06([0-9])|07([0-9])|08([0-9])|4([0-3][0-9]|8[5-9]|9[0-9])|5([0-9][0-9]|3[0-8])|9([0-6][0-9]|7[0-8])|7([0-2][0-9])|541|700|720|727|901)|65165([2-9])|6516([6-7][0-9])|65500([0-9])|6550([0-5][0-9])|655021|65505([6-7])|6516([8-9][0-9])|65170([0-4]))$/,
        format: /(\d{1,4})/g,
        length: [16],
        luhn: true,
        type: 'elo'
      }, {
        cvcLength: [3],
        pattern: /^(606282\d{10}(\d{3})?)|^(3841\d{15})$/,
        format: /(\d{1,4})/g,
        length: [13, 16, 19],
        luhn: true,
        type: 'hipercard'
      }, {
        cvcLength: [3],
        pattern: /^50[0-9]{17}$/,
        format: /(\d{1,4})/g,
        length: [16, 19],
        luhn: true,
        type: 'aura'
      }, {
        cvcLength: [3, 4],
        pattern: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
        format: /(\d{1,4})/g,
        length: [16],
        luhn: true,
        type: 'discover'
      }, {
        cvcLength: [3, 4],
        pattern: /^3[47][0-9]{13}$/,
        format: /(\d{1,4})/g,
        length: [15],
        luhn: true,
        type: 'amex'
      }, {
        cvcLength: [3, 4],
        pattern: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
        format: /(\d{1,4})/g,
        length: [14, 16],
        luhn: true,
        type: 'dinersclub'
      }, {
        cvcLength: [3],
        pattern: /^(5(018|0[23]|[68])|6(39|7))/,
        format: /(\d{1,4})/g,
        length: [12, 13, 14, 15, 16, 17, 18, 19],
        luhn: true,
        type: 'maestro'
      }, {
        cvcLength: [3],
        pattern: /^((5[1-5][0-9]{14})$|^(2(2(?=([2-9]{1}[1-9]{1}))|7(?=[0-2]{1}0)|[3-6](?=[0-9])))[0-9]{14})$/,
        format: /(\d{1,4})/g,
        length: [16],
        luhn: true,
        type: 'mastercard'
      }, {
        cvcLength: [3],
        pattern: /^4(026|17500|405|508|844|91[37])/,
        format: /(\d{1,4})/g,
        length: [16],
        luhn: true,
        type: 'visaelectron'
      }, {
        cvcLength: [3],
        pattern: /^4[0-9]{12}(?:[0-9]{3})?$/,
        format: /(\d{1,4})/g,
        length: [13, 16],
        luhn: true,
        type: 'visa'
      }, {
        cvcLength: [3],
        pattern: /^(637095)\d{0,10}$/,
        format: /(\d{1,4})/g,
        length: [16],
        luhn: false,
        type: 'hiper'
      }];
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      var creditCardValid = _payment.default.fns.validateCardNumber(event.target.value);

      if (!_this.state.stopChangingIssuer) {
        _this.setState({
          issuer: _payment.default.fns.cardType(event.target.value)
        });
      }

      _this.setState({
        value: event.target.value
      });

      _this.checkFilled(event.target.value);

      _this.checkValid(creditCardValid);

      _this.checkErrorMessage(creditCardValid);

      if (_this.props.onChange) _this.props.onChange(event);
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (event) {
      var creditCardValid = _payment.default.fns.validateCardNumber(event.target.value);

      _this.checkValid(creditCardValid);

      _this.checkErrorMessage(creditCardValid);

      if (_this.props.onBlur) _this.props.onBlur(_this.state.issuer);
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (event) {
      if (_this.props.onFocus) _this.props.onFocus(event);
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (card) {
      _this.setState({
        issuer: card,
        stopChangingIssuer: true
      });

      if (_this.props.onClick) _this.props.onClick(card);
    });

    _defineProperty(_assertThisInitialized(_this), "checkFilled", function (value) {
      if (value) _this.setState({
        isFilled: true
      });else _this.setState({
        isFilled: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "checkValid", function (valid) {
      if (valid) _this.setState({
        isValid: true
      });else _this.setState({
        isValid: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "checkErrorMessage", function (valid) {
      _this.setState({
        showErrorMessage: !valid
      });
    });

    return _this;
  }

  _createClass(InputCard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateCards();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var wrapperClass = (0, _classnames.default)('input', {
        'input--small': this.props.size === 'small',
        'input--shadow': this.props.withShadow === true
      }, this.props.className ? this.props.className.split(' ') : '');
      var inputClass = (0, _classnames.default)('input__field', {
        'input__field--filled': this.state.isFilled,
        'input__field--success': this.state.isValid === true,
        'input__field--error': this.state.isValid === false
      });
      var mask;
      var issuer = this.state.issuer;

      if (issuer === 'amex') {
        mask = [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];
      } else if (issuer === 'dinersclub') {
        mask = [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];
      } else if (['hipercard', 'mastercard', 'visa'].includes(issuer)) {
        mask = [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];
      } else {
        mask = [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];
      }

      return _react.default.createElement("div", {
        className: wrapperClass
      }, _react.default.createElement(_reactTextMask.default, {
        mask: mask,
        type: "tel",
        id: "cardNumber",
        value: this.state.value,
        name: this.props.name,
        disabled: this.props.disabled,
        maxLength: this.props.maxLength,
        className: inputClass,
        autoComplete: "off",
        onChange: this.handleChange,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        required: this.props.required
      }), _react.default.createElement("label", {
        className: "input__label",
        htmlFor: this.props.id
      }, this.props.label), this.state.showErrorMessage ? _react.default.createElement("p", {
        className: "input__error-message"
      }, "Cart\xE3o inv\xE1lido") : _react.default.createElement("p", {
        className: "input__error-message"
      }), this.props.thumbs === 'compact' ? _react.default.createElement(_Icon.default, {
        icon: "cc-".concat(this.state.issuer),
        className: "input__card"
      }) : null, this.props.thumbs === 'expanded' ? _react.default.createElement("ul", {
        className: "input-cc-expanded"
      }, this.props.availableCC.map(function (card) {
        return _react.default.createElement("li", {
          key: card
        }, _react.default.createElement(_Icon.default, {
          icon: "cc-".concat(card),
          width: "35",
          height: "26",
          className: _this2.state.issuer === card ? 'active' : '',
          onClick: function onClick() {
            return _this2.handleClick(card);
          }
        }));
      })) : null);
    }
  }]);

  return InputCard;
}(_react.Component);

InputCard.propTypes = {
  /** Classe adicional para o wrapper */
  className: _propTypes.default.string,

  /** Atributo value do input, caso precise vir pré-definido */
  value: _propTypes.default.string,

  /** ID do input para servir como `for` do label */
  id: _propTypes.default.string.isRequired,

  /** Label que referencia o input */
  label: _propTypes.default.string.isRequired,

  /** Callback para quando modificar o value do input */
  onChange: _propTypes.default.func,

  /** Callback para quando o focus sair do input */
  onBlur: _propTypes.default.func,

  /** Tamanho máximo de caracteres do input */
  maxLength: _propTypes.default.number,

  /** Atributo name do input */
  name: _propTypes.default.string,

  /** Atributo required do input */
  required: _propTypes.default.bool,

  /** Atributo disabled do input */
  disabled: _propTypes.default.bool,

  /** Array com as bandeiras de cartões disponíveis */
  availableCC: _propTypes.default.array,

  /** Shows the thumb in right side of input */
  thumbs: _propTypes.default.string
};
var _default = InputCard;
exports.default = _default;